module.exports = __webpack_public_path__ + "img/seat.645fac2d.svg";